import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetPlanReviewCandidateSubmissionTypesMutationVariables = Types.Exact<{
  candidateId: Types.Scalars['uuid']['input'];
  objects: Array<Types.Plan_Review_Candidate_Submission_Types_Insert_Input> | Types.Plan_Review_Candidate_Submission_Types_Insert_Input;
}>;


export type SetPlanReviewCandidateSubmissionTypesMutation = { __typename?: 'mutation_root', delete_plan_review_candidate_submission_types?: { __typename?: 'plan_review_candidate_submission_types_mutation_response', affected_rows: number } | null, insert_plan_review_candidate_submission_types?: { __typename?: 'plan_review_candidate_submission_types_mutation_response', affected_rows: number } | null };


export const SetPlanReviewCandidateSubmissionTypesDocument = gql`
    mutation setPlanReviewCandidateSubmissionTypes($candidateId: uuid!, $objects: [plan_review_candidate_submission_types_insert_input!]!) {
  delete_plan_review_candidate_submission_types(
    where: {candidate_id: {_eq: $candidateId}}
  ) {
    affected_rows
  }
  insert_plan_review_candidate_submission_types(objects: $objects) {
    affected_rows
  }
}
    `;
export type SetPlanReviewCandidateSubmissionTypesMutationFn = Apollo.MutationFunction<SetPlanReviewCandidateSubmissionTypesMutation, SetPlanReviewCandidateSubmissionTypesMutationVariables>;

/**
 * __useSetPlanReviewCandidateSubmissionTypesMutation__
 *
 * To run a mutation, you first call `useSetPlanReviewCandidateSubmissionTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPlanReviewCandidateSubmissionTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPlanReviewCandidateSubmissionTypesMutation, { data, loading, error }] = useSetPlanReviewCandidateSubmissionTypesMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useSetPlanReviewCandidateSubmissionTypesMutation(baseOptions?: Apollo.MutationHookOptions<SetPlanReviewCandidateSubmissionTypesMutation, SetPlanReviewCandidateSubmissionTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPlanReviewCandidateSubmissionTypesMutation, SetPlanReviewCandidateSubmissionTypesMutationVariables>(SetPlanReviewCandidateSubmissionTypesDocument, options);
      }
export type SetPlanReviewCandidateSubmissionTypesMutationHookResult = ReturnType<typeof useSetPlanReviewCandidateSubmissionTypesMutation>;
export type SetPlanReviewCandidateSubmissionTypesMutationResult = Apollo.MutationResult<SetPlanReviewCandidateSubmissionTypesMutation>;
export type SetPlanReviewCandidateSubmissionTypesMutationOptions = Apollo.BaseMutationOptions<SetPlanReviewCandidateSubmissionTypesMutation, SetPlanReviewCandidateSubmissionTypesMutationVariables>;